const KEY = 'solis:companySettings:v1';
const TTL_MS = 10 * 60 * 1000; // 10 dk

export const companySettingsCache = {
  get() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      const obj = JSON.parse(raw);
      if (!obj?.ts || !obj?.value) return null;
      const fresh = Date.now() - obj.ts < TTL_MS;
      return fresh ? obj.value : null;
    } catch {
      return null;
    }
  },
  set(value) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), value }));
    } catch {}
  },
  clear() {
    try {
      localStorage.removeItem(KEY);
    } catch {}
  },
};
